export default __webpack_public_path__ + "static/media/icon_fireman.55744f07.png";